import React, { useState } from "react";

import { gql } from "@examspark/api";
import { assertNativeError } from "@examspark/common";
import { Button, Form, TextInput, Toolbar, VSpace } from "@examspark/common-ui";
import { User } from "@examspark/types";

import { awsconfig } from "../../utils/util";

export const getUserBranchFromAWSConfig = () => {
  const env = awsconfig.aws_user_files_s3_bucket.match(/-([a-z]+)$/);
  return env?.[1] || "";
};

const ManageName = (props: {
  onChange?: (name: Pick<User, "firstName" | "lastName">) => void;
  user?: User;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState(props.user?.firstName ?? "");
  const [lastName, setLastName] = useState(props.user?.lastName ?? "");

  const handleUpdate = async () => {
    if (props.user == null) return;

    try {
      if (!firstName.length || !lastName.length) {
        throw new Error("First and last name are required.");
      }
    } catch (error) {
      assertNativeError(error);
      alert(error.message);
      return;
    }

    try {
      setIsLoading(true);
      await gql.operations.user.updateUserAccount({
        id: props.user?.id,
        sk: "user",
        firstName: firstName,
        lastName: lastName,
      });

      props.onChange?.({ firstName, lastName });
      setIsLoading(false);
    } catch (error) {
      alert("There was an error updating your name. Please try again later.");
    }
  };

  return (
    <VSpace>
      <Form.FieldGrid size="21rem">
        <Form.Field label="First Name">
          <TextInput
            value={firstName ?? ""}
            onChange={(e) => setFirstName(e.target.value)}
            // disabled={isLoading}
            onEnterKeyPress={handleUpdate}
            data-1p-ignore
          />
        </Form.Field>
        <Form.Field label="Last Name">
          <TextInput
            value={lastName ?? ""}
            onChange={(e) => setLastName(e.target.value)}
            // disabled={isLoading}
            onEnterKeyPress={handleUpdate}
            data-1p-ignore
          />
        </Form.Field>
        <Form.Field label="Email Address">
          <TextInput readOnly disabled value={props.user?.email ?? ""} />
        </Form.Field>
      </Form.FieldGrid>
      <Toolbar>
        <Button
          onClick={() => handleUpdate()}
          title="Update Name"
          disabled={isLoading}
          isLoading={isLoading}
        >
          Update Name
        </Button>
      </Toolbar>
    </VSpace>
  );
};

export default ManageName;
